import BMENewsModal from './BMENewsModal';

export default BMENewsModal;
